import { Component, OnInit } from '@angular/core';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material';
import {OfferModificationsService} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {SelectedOfferService} from '../../../../core/services/impl/section-services/selected-offer/selected-offer.service';
import {RegistrationService} from '../../../../core/services/impl/registration.service';
import {AssetsService} from '../../../services/assets.service';

@Component({
  selector: 'app-modified-offer-price-change-dialog',
  templateUrl: './modified-offer-price-change-dialog.component.html',
  styleUrls: ['./modified-offer-price-change-dialog.component.scss']
})
export class ModifiedOfferPriceChangeDialogComponent implements OnInit {

  policyPrice: number;
  instalmentsValues: number[];

  private readonly TRANSLATIONS_CONTAINER_KEY = 'MODIFIED_OFFER_PRICE_CHANGE_DIALOG_COMPONENT';

  static getConfigBuilder(): ModifiedOfferPriceChangeDialogConfig {
    return new ModifiedOfferPriceChangeDialogConfig();
  }

  get imageSrc(): string {
    return this.assetsService.informationDialogImageSrc;
  }

  constructor(private dialog: MatDialogRef<ModifiedOfferPriceChangeDialogComponent>,
              private assetsService: AssetsService,
              private selectedOfferService: SelectedOfferService,
              private registration: RegistrationService,
              private offerModificationsService: OfferModificationsService) { }

  ngOnInit() {
    this.initPrices();
  }

  buyOnline() {
    this.dialog.close({
      registerPolicy: true
    })
  }

  backToOffer() {
    this.offerModificationsService.additionalOptionsModified = false;
    this.dialog.close({
      registerPolicy: false
    })
  }

  getTranslationKey(key: string): string {
    return `${this.TRANSLATIONS_CONTAINER_KEY}.${key}`;
  }

  private initPrices(): void {
    const { premiumId } = this.registration.registration;
    const selectedPremium = this.selectedOfferService.selectedOffer.premiums.find(premium => premium.id === premiumId);
    this.policyPrice = selectedPremium.amount.amount;
    this.instalmentsValues = selectedPremium.instalments.map(instalment => instalment.value);
  }

}

export class ModifiedOfferPriceChangeDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'app-dialog',
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
